import { useEffect, useRef } from 'react';
import { registerUnsavedLeaveGuard } from '../utils/draftLeaveGuard';
import { UNSAVED_CHANGES_WARNING } from '../utils/writerCopy';

/**
 * Warn before reload and before in-app navigation while `active` is true.
 * Scene Writing passes its own draft sentence. Note forms use the default.
 * Does not save anything.
 */
export function useUnsavedChangesWarning(active, message = UNSAVED_CHANGES_WARNING) {
  const activeRef = useRef(Boolean(active));
  activeRef.current = Boolean(active);

  useEffect(() => {
    const onBeforeUnload = (event) => {
      if (!activeRef.current) return;
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, []);

  useEffect(() => registerUnsavedLeaveGuard(
    () => activeRef.current,
    message,
  ), [message]);
}
